// extracted by mini-css-extract-plugin
module.exports = {"logoutTimer":"logoutTimer_logoutTimer__1udvN"};